import React, { Component } from "react";
import { Button, Container, Table, Row, Col } from 'reactstrap';
import { Navigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import Moment from 'moment';

import { Snackbar } from '@mui/material';


import AuthService from "../services/LoginService";
import EventBus from "../common/EventBus";

import { AddSession } from "./AddSession";
import SessionFormationService from "../services/SessionFormationService";


class SessionList extends Component {

    emptySession = {
        location: '',
        startDate: '',
        endDate: '',
        formation: {
            id: '',
        }
    };


    constructor(props) {
        super(props);
        //var tempDate = new Date();
        //const lastMonth = tempDate.getFullYear() + '-' + (tempDate.getMonth()) + '-' + tempDate.getDate();
        this.state = {
            sessions: [],
            redirect: null,
            addSessionShow: false,
            currentSession: this.emptySession,
            snackbaropen: false,
            page: 1,
            count: 0,
            pageSize: 100,
            sessionNameFilter: '',
            minSessDtFilter: Moment('2020-01-01').format('yyyy-MM-DD'),
            maxSessDtFilter: Moment('2050-01-01').format('yyyy-MM-DD'),

        };
        this.pageSizes = [ 5, 25, 50, 100, 200];


        // this.remove = this.remove.bind(this);
        this.retrieveSessions = this.retrieveSessions.bind(this);
        // this.handlePageChange = this.handlePageChange.bind(this);
        this.remove = this.remove.bind(this);
        this.editFormation = this.editFormation.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    }

    componentDidMount() {
        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveSessions();
        }
    }

    /* componentDidUpdate(previousProps, CurrentState) {
         console.log('componentDidUpdate');
         console.log(this.props.currentformation);
 
         if (previousProps.currentstudent !== this.props.currentstudent) {
             console.log('mise a jour');
             this.retrieveSessions();
         }
     }*/
/*
    componentDidUpdate(previousProps, previousState) {
        console.log('update componenet');
        if (previousProps.currentsession !== this.props.currentsession) {

            this.retrieveSessions();
        }
    }
    */

    
    retrieveSessions() {
        const { sessionNameFilter, minSessDtFilter, maxSessDtFilter, page, pageSize } = this.state;
        const params = this.getRequestParams(sessionNameFilter, minSessDtFilter, maxSessDtFilter, page, pageSize);
        SessionFormationService.getAll(params).then((response) => {
            const { sessions, totalPages } = response.data;

                this.setState({
                    sessions: sessions,
                    count: totalPages,
                });
            //console.log(response.data);

        })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }

    getRequestParams(sessionNameFilter, minSessDtFilter, maxSessDtFilter, page, pageSize) {
        let params = {};

        if (sessionNameFilter) {
            params["sessionName"] = sessionNameFilter;
        }
        if (minSessDtFilter) {
            params["minSessionDate"] = minSessDtFilter;
        }
        if (maxSessDtFilter) {
            params["maxSessionDate"] = maxSessDtFilter;
        }
        if (page) {
            params["page"] = page - 1;
        }

        if (pageSize) {
            params["size"] = pageSize;
        }

        return params;
    }

    editFormation(session) {
        // studentId.preventDefault();
        //console.log('STUDENT List contactID = ' + contract.id);
        this.setState({ currentSession: session });
        this.setState({ addSessionShow: true });
    }

    remove(id) {
        SessionFormationService.delete(id)
            .then((response) => {
                const {  message } = response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
                this.retrieveSessions();
            })
            .catch((err) => {
                console.log(err);
                const {  message } = err.response.data;
                this.setState({ snackbaropen: true, snackbarmsg: message });
            });
    }

    snackbarClose = (event) => {
        this.setState({ snackbaropen: false });
    }

    handlePageSizeChange(event) {
        this.setState(
            {
                pageSize: event.target.value,
                page: 1
            },
            () => {
                this.retrieveSessions();
            }
        );
    }

    handlePageChange(event, value) {
        this.setState(
            {
                page: value,
            },
            () => {
                this.retrieveSessions();
            }
        );
    }


    render() {

        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }

        const {
            sessions,
            page,
            count,
            pageSize,
            isLoading,
        } = this.state;

        let addSessionClose = () => this.setState({ addSessionShow: false, currentSession: this.emptySession });

        if (isLoading) {
            return <p>Loading...</p>;
        }

        const formationList = sessions.map(session => {
            return <tr key={session.id}>
                <td>{session.name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{session.formation.name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{session.location}</td>
                <td>{Moment(session.startDate).format('DD/MM/yyyy')}</td>
                <td>{Moment(session.endDate).format('DD/MM/yyyy')}</td>

                <td>
                    <IconButton aria-label="edit" color="primary" onClick={() => { this.editFormation(session) }} >
                        <ModeEditIcon />
                    </IconButton>
                    <IconButton aria-label="delete" color="primary" onClick={() => this.remove(session.id)}>
                        <DeleteIcon />
                    </IconButton>


                </td>
            </tr>
        });

        const reload=()=>window.location.reload();

        return (
            <div>
                <Container>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        open={this.state.snackbaropen}
                        autoHideDuration={3000}
                        onClose={this.snackbarClose}
                        message={<span id='message-id'> {this.state.snackbarmsg}  </span>}
                        action={[
                            <IconButton
                                key="close"
                                aria-label='Close'
                                color='inherit'
                                onClick={this.snackbarClose}
                            >X</IconButton>
                        ]}
                    ></Snackbar>
                    <br />
                    <Row>
                        <Col xs={10} md={10}><h3>Sessions</h3></Col>
                        <Col xs={2} md={2}>
                            <Button onClick={() => { this.editFormation(this.state.currentSession) }}>Ajout Session</Button>
                        </Col>
                    </Row>

                </Container>
                <Container size="sm">

                    <br />

                    <Table striped hover size="sm">
                        <thead >
                            <tr >
                                <th width="25%">Libellé</th>
                                <th width="25%">Formation</th>
                                <th width="10%">Localisation</th>
                                <th width="15%">Date début</th>
                                <th width="15%">Date Fin</th>
                                <th width="10%">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formationList}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>

                                <td colSpan={4} >
                                    <Pagination
                                        className="mx-12"
                                        count={count}
                                        page={page}
                                        siblingCount={1}
                                        boundaryCount={1}
                                        variant="outlined"
                                        shape="rounded"
                                        onChange={this.handlePageChange}
                                    />

                                </td>
                                <td colSpan={2}>
                                    {"Items per Page: "}
                                    <select onChange={this.handlePageSizeChange} value={pageSize}>
                                        {this.pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>

                                </td>



                            </tr>
                        </tfoot>

                    </Table>

                    <AddSession show={this.state.addSessionShow} onHide={addSessionClose} onExit={reload} currentsession={this.state.currentSession} ></AddSession>
                </Container>
            </div>
        );
    }



}
export default SessionList;